import React from 'react';
import { Helmet } from 'react-helmet';

// Global Components
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import SaveMessage from 'components/SaveMessage';
import RoleGate from 'components/RoleGate';
import RoleButton from 'components/RoleButton';
// @ts-ignore
import Online from 'components/Online';

import { ADMIN } from 'components/RoleGate/constants';
import {
    CROPSURE_PASSWORD_CREATE_NAMESPACE,
    CROPSURE_PASSWORD_DELETE_NAMESPACE,
    CROPSURE_PASSWORD_UPDATE_NAMESPACE
} from 'services/cropsurePasswords/constants';
import {
    CREATE_MODAL_QUERY_STRING_PARAM,
    DELETE_MODAL_QUERY_STRING_PARAM
} from 'components/VirtualizedTable/constants';

import SpraySchemaExistsGate from 'components/SpraySchemaExistsGate';

// Local Components
import SingleActiveTableRowGate from 'components/SingleActiveTableRowGate';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { MdDelete } from 'react-icons/md';
import CropsurePasswordsVirtualizedTable from './components/CropsurePasswordsVirtualizedTable';
import CropsurePasswordsRequest from './components/CropsurePasswordsRequest';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

export class Spray extends React.PureComponent {
    render(): React.ReactElement {
        return (
            <SpraySchemaExistsGate>
                <RoleGate requiredRoles={[ADMIN]}>
                    <ErrorBoundary
                        namespace="Spray Settings"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Helmet>
                            <title>
                                Spray Settings - {REACT_APP_PROJECT_NAME}
                            </title>
                        </Helmet>
                        <Online>
                            <CropsurePasswordsRequest />
                        </Online>
                        <PageTitleAndFilters
                            title="Spray Settings"
                            searchInputPlaceholder="Search RPIN"
                            hideFilters
                            MessageComponent={
                                <SaveMessage
                                    namespace={[
                                        CROPSURE_PASSWORD_CREATE_NAMESPACE,
                                        CROPSURE_PASSWORD_UPDATE_NAMESPACE,
                                        CROPSURE_PASSWORD_DELETE_NAMESPACE
                                    ]}
                                />
                            }
                            FirstActionButton={
                                <SingleActiveTableRowGate>
                                    <RoleButton
                                        requiredRoles={[ADMIN]}
                                        params={{
                                            [DELETE_MODAL_QUERY_STRING_PARAM]:
                                                true
                                        }}
                                        buttonProps={{
                                            icon: true,
                                            color: 'black',
                                            basic: true,
                                            style: {
                                                marginRight: 0,
                                                marginLeft: 8
                                            }
                                        }}
                                    >
                                        <ButtonIconWrapper>
                                            <MdDelete
                                                style={{
                                                    fontSize: 20
                                                }}
                                            />
                                        </ButtonIconWrapper>
                                        Delete
                                    </RoleButton>
                                </SingleActiveTableRowGate>
                            }
                            SecondActionButton={
                                <RoleButton
                                    requiredRoles={[ADMIN]}
                                    params={{
                                        [CREATE_MODAL_QUERY_STRING_PARAM]: true
                                    }}
                                    ignoreSeason
                                    buttonProps={{
                                        secondary: true,
                                        style: {
                                            marginRight: 0,
                                            marginLeft: 8
                                        }
                                    }}
                                >
                                    Create New
                                </RoleButton>
                            }
                        />
                        <PageTitleAndFiltersPusher>
                            <CropsurePasswordsVirtualizedTable tableId="cropsure-passwords" />
                        </PageTitleAndFiltersPusher>
                    </ErrorBoundary>
                </RoleGate>
            </SpraySchemaExistsGate>
        );
    }
}

export default Spray;
